document.addEventListener('DOMContentLoaded', async () => {
  await import('helpers/prefetch').then((module) => module.default.init())

  // SHARED SPECIFIC
  const helpers = await import('helpers/helpers').then((module) => {
    return module
  })

  helpers.checkFrameRate()
  helpers.pageRestore()
  helpers.verticalResizeCheck()

  document.querySelector('.body').classList.remove('noscript')

  if (document.querySelector<HTMLElement>('.pipes')) {
    await import('helpers/pipe-helpers').then((module) => module.pipeHelpers.init())
  }

  if (document.querySelector<HTMLElement>('.body')) {
    import('helpers/smooth-scroll').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.breadcrumbs')) {
    import('shared/sections/breadcrumbs').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.header')) {
    import('shared/sections/header').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.header-navigation')) {
    import('shared/components/header-navigation').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.hero')) {
    import('shared/sections/hero').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.picture')) {
    import('shared/components/picture').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.swiper')) {
    import('shared/components/swiper').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.video')) {
    import('shared/components/video').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.full-width-image-block')) {
    import('shared/blocks/full-width-image-block').then((module) => module.default.init())
  }

  // RESOURCE PARK SPECIFIC
  if (document.querySelector<HTMLElement>('.rp-cta-alternative-block')) {
    import('resourcepark/blocks/cta-alternative-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.rp-info-data-block__globe')) {
    import('resourcepark/components/globe').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.rp-resources-block')) {
    import('resourcepark/blocks/resources-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.rp-video-block')) {
    import('resourcepark/blocks/video-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.footer')) {
    import('shared/sections/footer').then((module) => module.default.init())
  }

  // SHARED SPECIFIC
  if (document.querySelector<HTMLElement>('.pipes')) {
    import('shared/components/block-pipes').then((module) => module.default.init())
  }

  if (!helpers.isProduction) {
    helpers.contentEditable.init()
    import('helpers/overlay-grid').then((module) => module.default.init())
  }

  helpers.removePreload()
})
